import React, { useCallback } from 'react';
import { Switch, Route } from 'react-router-dom';
// import RouteWithPermission from 'components/RouteWithPermission/RouteWithPermission';
// import { isRoles } from 'core/permission/PermissionDSL';
// import { RoleNames } from 'core';
// import { ROUTE_PATH } from 'enum/RoutePath';
// import {
//   CreateMerchantFormModel,
//   EditMerchantFormModel
// } from './MerchantFormModel';
// import { MerchantDetail } from './MerchantDetail';
import { MerchantList } from './MerchantList';
// import { MerchantForm } from './MerchantForm';

export const Merchants: React.FC = () => {
  // const createMerchantFormModel: CreateMerchantFormModel = useMemo(() => {
  //   return new CreateMerchantFormModel();
  // }, []);

  // const editMerchantFormModelRef = useRef<EditMerchantFormModel>();
  // const getEditAdvertiserFormModel = useCallback(
  //   (advertiserId: number | string) => {
  //     if (editMerchantFormModelRef.current) {
  //       return editMerchantFormModelRef.current;
  //     }
  //     editMerchantFormModelRef.current = new EditMerchantFormModel(
  //       advertiserId
  //     );
  //     return editMerchantFormModelRef.current;
  //   },
  //   []
  // );

  // const renderMerchantDetailView = useCallback(props => {
  //   const advertiserId = props.match.params.advertiserId;
  //   return <MerchantDetail advertiserId={Number(advertiserId)} />;
  // }, []);

  const renderMerchantHome = useCallback(() => {
    return <MerchantList />;
  }, []);

  // const renderCreateMerchantPage = useCallback(
  //   props => {
  //     return <MerchantForm model={createMerchantFormModel} {...props} />;
  //   },
  //   [createMerchantFormModel]
  // );

  // const renderEditMerchantPage = useCallback(
  //   props => {
  //     const advertiserId = props.match.params.advertiserId;
  //     return (
  //       <MerchantForm
  //         model={getEditAdvertiserFormModel(advertiserId)}
  //         {...props}
  //       />
  //     );
  //   },
  //   [getEditAdvertiserFormModel]
  // );

  return (
    <Switch>
      {/* <RouteWithPermission
        permissionAware={isRoles(RoleNames.beaconAdmin)}
        redirectPath={`/merchants/new/${ROUTE_PATH.ERROR403}`}
        path={'/merchants/new'}
        render={renderCreateMerchantPage}
      /> */}
      {/* <RouteWithPermission
        permissionAware={isRoles(RoleNames.beaconAdmin)}
        redirectPath={`/merchants/:advertiserId/edit/${ROUTE_PATH.ERROR403}`}
        path={'/merchants/:advertiserId/edit/'}
        render={renderEditMerchantPage}
      /> */}
      {/* <Route
        path={'/merchants/:advertiserId'}
        render={renderMerchantDetailView}
      /> */}
      <Route render={renderMerchantHome} />
    </Switch>
  );
};
